var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3H11.5V7.9H12.5V3C12.5 2.73478 12.3946 2.48043 12.2071 2.29289C12.0196 2.10536 11.7652 2 11.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V15C2.5 15.2652 2.60536 15.5196 2.79289 15.7071C2.98043 15.8946 3.23478 16 3.5 16H11.5C11.7652 16 12.0196 15.8946 12.2071 15.7071C12.3946 15.5196 12.5 15.2652 12.5 15H3.5V3Z",
    fill: "#5BCD15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0799 8.64C13.9843 8.55809 13.8613 8.51528 13.7354 8.52014C13.6096 8.52501 13.4902 8.57717 13.4012 8.66622C13.3121 8.75527 13.2599 8.87463 13.2551 9.00047C13.2502 9.12631 13.293 9.24935 13.3749 9.345L15.0649 11H7.81494C7.68233 11 7.55516 11.0527 7.46139 11.1464C7.36762 11.2402 7.31494 11.3674 7.31494 11.5C7.31494 11.6326 7.36762 11.7598 7.46139 11.8536C7.55516 11.9473 7.68233 12 7.81494 12H15.0649L13.3749 13.73C13.3226 13.7748 13.2801 13.83 13.2501 13.892C13.2201 13.954 13.2032 14.0216 13.2005 14.0905C13.1979 14.1593 13.2095 14.228 13.2346 14.2922C13.2598 14.3563 13.2979 14.4146 13.3466 14.4633C13.3953 14.5121 13.4536 14.5502 13.5178 14.5753C13.5819 14.6005 13.6506 14.6121 13.7195 14.6094C13.7883 14.6067 13.8559 14.5899 13.9179 14.5599C13.98 14.5299 14.0351 14.4873 14.0799 14.435L16.9999 11.535L14.0799 8.64Z",
    fill: "#5BCD15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitGreen);
export default __webpack_public_path__ + "static/media/exit_green.28cc4baceefc3e7a2fadd0091791ab75.svg";
export { ForwardRef as ReactComponent };